<template>
    <!-- tab 选择框 -->
    <div class="tab-select-box flex-jf-btw">
        <ul class="flex">
           <slot>这里输入tab选项</slot>
        </ul>      
    </div>
</template>
<script>
    export default {
        props:[]
    }
</script>
<style lang="less" scoped>
    .tab-select-box{
        line-height: 3.3rem;
        //border-bottom: .05rem solid #EFEFEF;
        ul{
            li{
                padding:0 1.5rem;
                font-size:.8rem;
                color:#000;
                cursor: pointer;
                border-bottom: .1rem solid transparent;
            }
            li:hover,li.active{
                border-bottom: .1rem solid #105DF3;
                color:#105DF3;
            }
        }
        >div{
            width:7rem;
            height:1.9rem;
            line-height: 1.9rem;
            margin:.8rem 1.5rem 0 0;
            background: #FBFBFB;
            border:.05rem solid #D1D1D1;
            border-radius: .2rem;
            text-align: center;
        }
    }
    
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/tabSelect.vue